interface WeekChartProps {
  weekData: {
    day: string
    hours: number
    maxHours?: number
  }[]
}

export function WeekChart({ weekData }: WeekChartProps) {
  const maxHours = Math.max(...weekData.map(d => d.maxHours || d.hours), 8)

  return (
    <div className="mt-4">
      <div className="flex items-end justify-between space-x-2">
        {weekData.map((data, index) => (
          <div key={index} className="flex-1 flex flex-col items-center">
            <div className="w-full h-24 bg-gray-100 rounded-t relative">
              <div 
                className="absolute bottom-0 w-full bg-primary-500 rounded-t transition-all duration-300"
                style={{ 
                  height: `${(data.hours / maxHours) * 100}%`,
                  minHeight: data.hours > 0 ? '4px' : '0px'
                }}
              />
            </div>
            <div className="mt-2 text-xs font-medium text-gray-600">
              {data.day}
            </div>
            <div className="text-xs text-gray-500">
              {data.hours}h
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}